import React from 'react';
import PropTypes from 'prop-types';
import { string } from 'yup';
import BaseInput from '../base';

const LoanOfficer = props => (
  <BaseInput
    name="loanOfficer"
    label="Loan Officer Name (optional)"
    type="text"
    autoComplete="nope"
    transparent
    maxLength="50"
    validate={val =>
      string()
        .notRequired()
        .matches(/^[a-zA-Z \-']+$/, {
          message: 'Enter a valid loan officer name',
          excludeEmptyString: true
        })
        .min(3, 'Loan officer name must be greater than 3 charcaters')
        .max(30, 'Loan officer name cannot be greater than 30 characters')
        .validate(val)
        .then(() => null)
        .catch(err => err.errors.join(', '))
    }
    {...props}
  />
);

LoanOfficer.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
  error: PropTypes.string
};

LoanOfficer.defaultProps = {
  value: '',
  error: ''
};

export default LoanOfficer;
